import React from "react";
import NYMLogo from "../assets/nym.png";

const Footer = () => {
  return (
    <footer className="bg-white text-black">
      {/* Main Footer Content */}
      <div className="border-t border-white/20">
        <hr />
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6">
            {/* Logo and Company Info */}
            <div className="flex justify-center md:justify-start">
              <img src={NYMLogo} alt="NYM Logo" className="h-10 w-auto" />
            </div>

            {/* Quick Links */}
            <div className="flex justify-center md:justify-end">
              <ul className="flex flex-wrap justify-center gap-4 text-sm">
                <li>
                  <a href="/about" className="hover:underline">About NYM</a>
                </li>
                <li>
                  <a href="https://career.thisisnym.com" className="hover:underline">Careers</a>
                </li>
                <li>
                  <a href="/product" className="hover:underline">Our Product</a>
                </li>
                <li>
                  <a href="/what-we-do" className="hover:underline">Services</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/20 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm">
          <p>© 2025. All rights reserved.</p>
          <a href="http://thisisnym.com" className="underline font-semibold pt-5">NYM Technologies Limited</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
